import React from 'react';
import { useBlock } from './SiteContent';

const DEFAULT = {
  items: [
    { id: 'step1', name: 'Знакомство',          desc: 'Вы пишете мне в Telegram или оставляете заявку. Это ни к чему не обязывает. Мы просто договариваемся о времени.' },
    { id: 'step2', name: 'Первая встреча',      desc: 'Это пространство, где вы — главный. Мы знакомимся. Вы выбираете, о чём говорить сегодня, а что оставить при себе. Я рядом. Я слушаю.' },
    { id: 'step3', name: 'Процесс',             desc: 'Встречаемся в вашем ритме, обычно раз в неделю. Где-то работаем с мыслями, где-то — с ощущениями в теле. Иногда достаточно выговориться. Важно выполнять заданные техники между сессиями.' },
    { id: 'step4', name: 'Результат и свобода', desc: 'Вы начнёте замечать, как что-то меняется внутри. Станет спокойнее. Появится ясность. Моя цель — не привязать вас к сессиям на годы, а дать инструменты, чтобы вы справлялись сами.' },
  ],
};

export default function HowItWorks() {
  const block = useBlock('how', DEFAULT);
  const steps = block.items?.length ? block.items : DEFAULT.items;
  return (
    <section id="how" className="py-16 md:py-24 bg-oat" data-testid="how-it-works">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="reveal text-center mb-12 md:mb-14">
          <div className="flex items-center justify-center gap-3 mb-4 text-[12px] tracking-[0.24em] uppercase text-wine/70">
            <span className="gold-divider" />
            <span>как это работает</span>
            <span className="gold-divider" />
          </div>
          <h2 className="font-heading text-3xl md:text-[44px] text-ink leading-tight">
            Четыре шага, чтобы&nbsp;начать
          </h2>
          <p className="text-ink/65 mt-4 max-w-xl mx-auto text-[15px]">
            Идти к&nbsp;психологу впервые страшно — и&nbsp;это нормально. Расскажу, как устроено у&nbsp;меня.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-8 md:gap-6">
          {steps.map((s, i) => (
            <div
              key={s.id || i}
              className="reveal relative"
              style={{ transitionDelay: `${i * 80}ms` }}
              data-testid={`step-${i + 1}`}
            >
              <div className="font-heading text-5xl text-wine/85 mb-2">
                {String(i + 1).padStart(2, '0')}
              </div>
              <div className="w-10 h-px bg-gold mb-4" />
              <h3 className="font-heading text-xl md:text-2xl text-ink mb-3 leading-tight">{s.name}</h3>
              <p className="text-[15px] text-ink/70 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
